var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Outline/person-add"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 5C11.103 5 12 5.897 12 7C12 8.103 11.103 9 10 9C8.897 9 8 8.103 8 7C8 5.897 8.897 5 10 5ZM10 11C12.206 11 14 9.206 14 7C14 4.794 12.206 3 10 3C7.794 3 6 4.794 6 7C6 9.206 7.794 11 10 11ZM10 13C6.141 13 3 16.14 3 20C3 20.552 3.447 21 4 21C4.553 21 5 20.552 5 20C5 17.243 7.243 15 10 15C12.757 15 15 17.243 15 20C15 20.552 15.447 21 16 21C16.553 21 17 20.552 17 20C17 16.14 13.859 13 10 13ZM20 6H21C21.55 6 22 6.45 22 7C22 7.55 21.55 8 21 8H20V9C20 9.55 19.55 10 19 10C18.45 10 18 9.55 18 9V8H17C16.45 8 16 7.55 16 7C16 6.45 16.45 6 17 6H18V5C18 4.45 18.45 4 19 4C19.55 4 20 4.45 20 5V6Z",
    fill: "#0C2551"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_1139",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 19,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Mask_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 5C11.103 5 12 5.897 12 7C12 8.103 11.103 9 10 9C8.897 9 8 8.103 8 7C8 5.897 8.897 5 10 5ZM10 11C12.206 11 14 9.206 14 7C14 4.794 12.206 3 10 3C7.794 3 6 4.794 6 7C6 9.206 7.794 11 10 11ZM10 13C6.141 13 3 16.14 3 20C3 20.552 3.447 21 4 21C4.553 21 5 20.552 5 20C5 17.243 7.243 15 10 15C12.757 15 15 17.243 15 20C15 20.552 15.447 21 16 21C16.553 21 17 20.552 17 20C17 16.14 13.859 13 10 13ZM20 6H21C21.55 6 22 6.45 22 7C22 7.55 21.55 8 21 8H20V9C20 9.55 19.55 10 19 10C18.45 10 18 9.55 18 9V8H17C16.45 8 16 7.55 16 7C16 6.45 16.45 6 17 6H18V5C18 4.45 18.45 4 19 4C19.55 4 20 4.45 20 5V6Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_1139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\x8E\xA8 Color"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 24,
    height: 24,
    fill: "currentColor"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonAdd);
export default __webpack_public_path__ + "static/media/person-add.5ec2565427cf7a0439f7d9db7d81a52c.svg";
export { ForwardRef as ReactComponent };